import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthShell from "@/components/AuthShell";
import { useAuth, errMsg } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await login(phone, password);
      if (data.must_change_password) {
        navigate("/change-password");
      } else {
        navigate("/app");
      }
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Welcome back"
      subtitle="Log in with your phone number to keep training."
      footer={
        <>
          Haven't set up yet?{" "}
          <Link to="/register" className="text-brand font-semibold hover:underline">Claim your account</Link>
          <span className="mx-2">·</span>
          <Link to="/help" className="text-brand font-semibold hover:underline">Help Desk</Link>
        </>
      }
    >
      <form onSubmit={submit} className="space-y-5">
        <div>
          <Label htmlFor="phone">Phone number (username)</Label>
          <Input id="phone" data-testid="login-phone" value={phone} onChange={(e) => setPhone(e.target.value)}
            placeholder="10-digit phone number" className="mt-1.5 border-brand-line bg-white" />
        </div>
        <div>
          <Label htmlFor="password">Password</Label>
          <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="Your password" className="mt-1.5 border-brand-line bg-white" />
        </div>
        <Button type="submit" data-testid="login-submit" disabled={loading} className="w-full rounded-full brand-btn h-11">
          {loading ? "Signing in..." : "Log in"}
        </Button>
      </form>
    </AuthShell>
  );
}
